import { store } from "../store/store";
import { getDomain } from "sinao-corejs";
import MarkdownIt from "markdown-it";
import TurndownService from "turndown";

const mdToHtmlService = new MarkdownIt({ html: true, breaks: false }); // md -> html
const htmlToMdService = new TurndownService({
	headingStyle: 'setext',
	bulletListMarker: '-'
}); // html -> md


htmlToMdService.addRule('lineBreak', {
  filter: 'br',
  replacement: function (content) {
    return '<br>\n'; // ou ce que tu veux à la place
  }
});

/*
htmlToMdService.addRule('collapseNbsp', {
	filter: function(node) {
		return node.nodeType === 3 && /(?:\u00A0|&nbsp;){2,}/.test(node.nodeValue || '');
	},
	replacement: function(content, node) {
		return (node.nodeValue || '').replace(/(?:\u00A0|&nbsp;){2,}/g, '&nbsp;');
	}
});
*/

/*
htmlToMdService.addRule('collapseSpace', {
	filter: function(node) {
		return node.nodeType === 3 && /\s{2,}/.test(node.nodeValue || '');
	},
	replacement: function(content, node) {
		return (node.nodeValue || '').replace(/\s{2,}/g, ' ');
	}
});
*/


htmlToMdService.addRule('lineBreakToBr', {
	filter: function(node) {
		return node.nodeType === 3 && /\s{2,}\n/.test(node.nodeValue || '');
	},
	replacement: function(content, node) {
		return (node.nodeValue || '').replace(/\s{2,}\n/g, '<br>');
	}
});


// Remplace les \n et \r\n par &nbsp; dans le texte
/*
htmlToMdService.addRule('newlineToNbsp', {
	filter: function (node) {
		// S'applique aux noeuds de texte uniquement
		return node.nodeType === 3 && /\r?\n/.test(node.nodeValue);
	},
	replacement: function (content, node) {
		return node.nodeValue.replace(/\r?\n/g, '<br>'); // ou '&nbsp;' selon ce que tu veux
	}
});
*/

htmlToMdService.addRule('emptyParagraphWithBr', {
  filter: function (node) {
		const match = (
			node.nodeName.toLowerCase() === 'p' &&
			node.childNodes.length === 1 &&
			node.firstChild.nodeName.toLowerCase() === 'br'
		);

		return match;
  },
  replacement: function (content, node) {
    return '<p><br></p>\n' ; // ou ce que tu veux
  }
});


htmlToMdService.addRule('paragraph', {
	filter: function (node) {
		if (node.nodeName.toLowerCase() !== 'p') return false;

		const isEmptyParagraphWithBr =
			node.childNodes.length === 1 &&
			node.firstChild.nodeName.toLowerCase() === 'br';

		const match = !isEmptyParagraphWithBr;

		return match;
	},
	replacement: function (content, node) {
		return '\n' + content + '  \n';
	}
});

const sanitizeMarkdown = text => {
    if (!text) return "";

    const result = text
		.split('\n')
		.map(line => line.trim())
        .filter(line => line.length > 0)
        .map(line => /^\s*(?:&nbsp;|\u00A0)\s*$/i.test(line) ? '<p><br></p>' : line)
		.map(line => line.replace(/&nbsp;|\u00A0/g, ' '))
        .map(line => /^\s*[-*+]\s+/.test(line) ? line.replace(/^\s+/, '') : line) // for lists
		.map(line => mdToHtmlService.render(line))
		.map(line => line.replace(/\\(<\/(?:ol|ul|li)>)/g, '$1')) // remove trailing \ before closing list tags
        .join('\n');
	
	return result;
}

function mdToHtml(text) {
	const sanitized = sanitizeMarkdown(text);
	return sanitized;
}

/*function normalizeMdToHtml(text) {
	if (!text) return "";

	//console.log('[normalizeMdToHtml #1] input text', text);
	const normalizedText = text//.replace(/(\r\n){1,}/g, '<br>')
		//.replace(/\s{2,}\n/g, '<br>\n')
		.replace(/&nbsp;/g, '\n<br>\n')
		.split('\n')
		.map(line => /^\s*(?:&nbsp;|\u00A0)\s*$/i.test(line) ? '\n<br>\n' : line)
		.map(line => line.replace(/[ \t]+$/g, ''))
		.map(line => /^\s*[-*+]\s+/.test(line) ? line.replace(/^\s+/, '') : line)
		//.map(line => /^<p><br><\/p>$/i.test(line) ? '<p></p>' : line)
		.join('\n')
		.trim();

	//console.log('[normalizeMdToHtml #2]', normalizedText);

	return normalizedText;
}*/


function addBrToEmptyParagraphs(text) {
	if (!text) return "";

	return text.replace(/<p>\s*<\/p>/gi, '\n<br>\n')
		.replace(/<p>\s*(?:&nbsp;|\u00A0)\s*<\/p>/gi, '\n<br>\n')
		.replace(/<p>\s*<br\s*<\/p>/gi, '\n<br>\n');
}

function htmlToMd(text) {
	const sourceHtml = addBrToEmptyParagraphs(text ?? "");
	const encodedText = htmlToMdService.turndown(sourceHtml).trim(); //.replace(/\n\s*\n/g, "<br>")
	return encodedText;
}


const getUrlParams = search => {
	const hashes = search.slice(search.indexOf("?") + 1).split("&");
	const params = {};

	hashes.map(hash => {
		const [key, val] = hash.split("=");
		params[key] = decodeURIComponent(val);
	});

	return params;
};

/**
 * Output a billing number from the specified format
 * @param {String} format Format to be applied
 * @param {{String, String, String}} options Options to be inserted in the format
 * @returns {String}
 */
const constructBillingNumber = (format, { prefix, separator, start, length }) => {
	const formatStart = String(Number(start)).padStart(length, "0");
	const year = new Date().getFullYear();
	const year2 = new Date()
		.getFullYear()
		.toString()
		.substr(-2);
	const month = (new Date().getMonth() + 1).toString().padStart(2, "0");

	let string = format.replace(/{prefix}/gi, prefix ?? "");

	string = string.replace(/{separator}/gi, separator ?? "");
	string = string.replace(/{start}/gi, formatStart ?? "");
	string = string.replace(/{year}/gi, year ?? "");
	string = string.replace(/{year2}/gi, year2 ?? "");
	string = string.replace(/{month}/gi, month ?? "");

	return string;
};

// Evaluate the most readable text color for a given background color
const calculateTextColor = color => colorToBW(invertColor(color));

/**
 * Invert all channels of an hex coded color and return a hex value
 * @param {string} color 3bits hex value of the color
 */
const invertColor = color => {
	// Input validation
	if (typeof color !== "string") {
		throw `Invalid type, expected string got ${typeof color}`;
	}

	if (color.length > 7 || color.length < 6) {
		throw "Invalid color format, expect a 3 bits hex value with or without the # (e.g. ffffff or #ffffff)";
	}

	// Extract the # if it exist and save it for re insertion at the end of the process
	const prefix = color.includes("#") ? "#" : "";

	color = color.includes("#") ? color.substring(1, 7) : color;

	// Separate channels
	const r = color.slice(0, 2);
	const g = color.slice(2, 4);
	const b = color.slice(4, 6);

	// Invert and re assemble the channels
	color = invertChannel(r) + invertChannel(g) + invertChannel(b);

	return prefix + color;
};

/**
 * Flip a hex scale 0-255 become 255-0
 * @param {string} channel 1 bit hex value of the channel
 */
const invertChannel = channel => {
	let c = parseInt(channel, 16);

	c = 255 - c;
	c = c.toString(16);

	return c;
};

/**
 * Clamp a hex color to black or white
 * @param {string} color 3 bits hex value of the color to clamp
 */
const colorToBW = color => {
	// Remove the # from string
	const prefix = color.includes("#") ? "#" : "";

	color = color.includes("#") ? color.substring(1, 7) : color;

	// Average out all channels and chose the nearest value between ffffff (white) and 000000 (black)
	color =
		(parseInt(color.slice(0, 2), 16) + parseInt(color.slice(2, 4), 16) + parseInt(color.slice(4, 6), 16)) / 3 > 127
			? "ffffff"
			: "000000";

	return prefix + color;
};

// generate a uuid for the component
const generateUUID = () =>
	"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
		const r = (Math.random() * 16) | 0,
			v = c == "x" ? r : (r & 0x3) | 0x8;

		return v.toString(16);
	});

const dispatchEvent = function({ modalName, source, action, data }) {
	try {
		const url = window.location != window.parent.location ? document.referrer : document.location.href;

		const domain = getDomain(url);

		if (domain !== 'sinao.fr') {
			window.parent.postMessage({ modalName, source, action, data }, "*");
		}
	} catch (error) {
		console.error(error);
	}
};

const interceptEvent = function(event) {
	const { origin, data } = event;
	const { action, json } = data;

	const domain = getDomain(origin);

	if (domain !== 'sinao.fr') {
		if (action === "REFRESH_RELATIONSHIPS") {
			store.commit("contactInfos", { ...json, modal: true });
			store.dispatch("relationships", {contact: json});
		}
		else if (action === "REFRESH_ESTABLISHMENT_PLACE") {
			store.commit("updateContactInfosEstablishmentPlace", JSON.parse(json));
		}
		else if (action === "REFRESH_ESTABLISHMENT_CONTACT") {
			store.commit("updateContactInfosEstablishmentContact", JSON.parse(json));
		}
	}
};

const formatDate = (dateString, US = false) => {
	if (!dateString) {
		return;
	}

	const date = new Date(dateString);

	/*
	if (toISOString) {
		const dateWithNoMs = new Date(date).setMilliseconds(0);

		return new Date(dateWithNoMs).toISOString().replace(".000Z", "Z");
	}
	*/

	const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;

	const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;

	const year = date.getFullYear();

	if (US) {
		return `${year}-${month}-${day}`;
	}

	return `${day}/${month}/${year}`;
};

const isToday = myDate => {
	const _myDate = new Date(myDate);
	const today = new Date();

	return (
		_myDate.getDate() == today.getDate() &&
		_myDate.getMonth() == today.getMonth() &&
		_myDate.getFullYear() == today.getFullYear()
	);
};

const addTimeToDate = (myDate, myTime = null) => {
	let dateWithTime = null;

	if (myTime) {
		dateWithTime = new Date(myDate.setTime(myTime)).setMilliseconds(0);
	} else {
		const time = new Date().getTime();

		dateWithTime = new Date(new Date().setTime(time)).setMilliseconds(0);
	}

	return new Date(dateWithTime).toISOString().replace(".000Z", "Z");
};

const reformatDateToIsoString = dateString => {
	if (!dateString) {
		return null;
	}

	const b = dateString.split(/\D/);

	return `${b[0]}-${b[1]}-${b[2]}T00:00:00Z`;
};

const reformatIsoStringToDate = isoString => {
	if (!isoString) {
		return null;
	}

	// Turn the ISO date to the local date
	const date = new Date(isoString);

	// Format date to the US format yyyy-mm-dd
	return formatDate(date, true);
};

const filterObjectsByKey = (array, keyToCompare) => {
	if (array.length > 1) {
		const _array = array;
		const uniqueArray = [_array[0]];

		for (let i = 0; i < _array.length; i++) {
			let isUnique = true;

			for (let j = 0; j < uniqueArray.length; j++) {
				if (_array[i][keyToCompare] === uniqueArray[j][keyToCompare]) {
					isUnique = false;
					break;
				}
			}

			if (isUnique) {
				uniqueArray.push(array[i]);
			}
		}

		return uniqueArray;
	}

	return array;
};

const  validateEmail = (email) =>  {
	var re = /\S+@\S+\.\S+/;
	return re.test(email);
}

const stringify_array_value = (arr) => {
	const opening_stringify_value = "[";
	const closing_stringify_value = "]";
	let stringify_value = arr.reduce(
		(accumulator, currentValue) => accumulator + '"' + currentValue + "',",
		opening_stringify_value,
	)
	// remove last comma and add closing ]
	return stringify_value.substring(0, stringify_value.length - 1) + closing_stringify_value;
}

function findUrlParam(param_name) {
	// return an Object with pairs {key: value}
	const query = window.location.search.substring(1); // Remove the "?" at the start
	const pairs = query.split("&");
	const params = {};

	for (let i = 0; i < pairs.length; i++) {
		const [key, value] = pairs[i].split("=");
		if (key) {
			params[decodeURIComponent(key)] = decodeURIComponent(value || "");
		}
	}

	return params[param_name] ?? null;
}

function getIndexesByContactEmail(establishments, email) {
	// get establishment e_index index and establishmentContact c_index for the given email
	const e_index = establishments.findIndex(e => e.contacts.find(c => c.email === email) !== undefined);
	let c_index = null;
	if (e_index >= 0) {
		c_index = establishments[e_index].contacts.findIndex(c => c.email === email);
	}
	return {
		e_index: e_index,
		c_index: c_index
	};
}

function isEmpty($value) {
	const emptyValues = ["", "0", "false", "null", "undefined"];
	return emptyValues.includes(String($value).toLowerCase().trim());
}

// Escape numbered list markers ("1. ") to prevent showdown from creating <ol>
const escapeMdLists = (text) => text ? text.replace(/^(\d+)\. /gm, '$1\\. ') : '';


const  debouncer = (method, duration) => {
	return setTimeout(() => {
		method();
	}, duration);
}

export {
	getUrlParams,
	constructBillingNumber,
	calculateTextColor,
	invertChannel,
	colorToBW,
	generateUUID,
	dispatchEvent,
	interceptEvent,
	formatDate,
	isToday,
	addTimeToDate,
	reformatDateToIsoString,
	reformatIsoStringToDate,
	filterObjectsByKey,
	validateEmail,
	stringify_array_value,
	findUrlParam,
	isEmpty,
	getIndexesByContactEmail,
	escapeMdLists,
	mdToHtml,
	htmlToMd,
	debouncer,
	addBrToEmptyParagraphs

};
